export default "__VITE_ASSET__CC$TVroN__"